const qs = require('qs')
const { showError } = require('../libs/helper')

module.exports = {
  getUserData: async (g, params) => {
    const result = await g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}sensus-pengguna/get-cookies`,
      params,
    })
      .then(res => res.data)
      .catch(err => {
        showError(g, err, 'Error Get Data')
      })
    return result
  },
  login: (g, data) => g.$http({
    url: 'https://jakaset.jakarta.go.id/api_login/api/auth',
    data: qs.stringify(data),
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  })
    .then(async ({ data: dataVar }) => {
      let success
      let dataUser
      let fromDb
      let realDb
      if (dataVar.success) {
        ({
          mapping_user: dataUser,
          success,
          mapping_user: dataUser,
          from_db: fromDb,
          real_db: realDb,
        } = dataVar)
      } else {
        throw dataVar.success === false ? dataVar.status : dataVar
      }

      return {
        isSuccess: success, data: dataUser, fromDb, realDb,
      }
    })
    .catch(err => {
      console.log(err);
      showError(g, { request: err }, 'Error Login')
      return { isSuccess: false, error: err }
    }),
}
